import * as angular from 'angular';
import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';

const DbSkipComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['AnalyticsService', '$window', '$element'];
    private linkDest: string;
    private linkText: string;
    private orgId: string;
    constructor(
      private analyticsService: AnalyticsService,
      private $window: angular.IWindowService,
      private $element: angular.IRootElementService
    ) {}

    $onInit() {
      const linkElement = this.$element.find('.link-text').get(0);
      this.analyticsService.run(
        RunMethodType.TrackLink,
        linkElement,
        AnalyticsEvent.Name.SkippedDBConnectionSignUpStep,
        {
          orgId: this.orgId,
        }
      );
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    linkDest: '@',
    linkText: '@',
    orgId: '@',
  },
  template: `
    <div class="link-container">
      <a class="link-text" ng-cloak href="{{ ctrl.linkDest }}" target="_self">{{ ctrl.linkText }}</a>
      <span class="arrow">&rarr;</span>
    </div>
  `,
};

export { DbSkipComponent };

angular.module('mode.components').component('dbSkip', DbSkipComponent);
